import { Box, Button } from '@mui/material'
import { Trans } from '@lingui/macro'
import { FC } from 'react'
import { ContactFields } from './ContactFields'
import Loading from 'egret/components/EgretLoadable/Loading'
import { ContactParsed } from 'app/services/sfAuth/sfData/sfContact'
import { AlertBanner } from 'app/views/common/alerts/AlertBanner'
import CustomButton from '../CustomButton'
import { ContactDialogType } from './useContactDialog'
import { isNil } from 'lodash'

interface ContactFieldsInfoProps {
  loading: boolean
  values: ContactParsed
  onEdit: (isMissingInfo: boolean) => void
  onSwitch: () => void
  onClose: () => void
  type?: ContactDialogType
  role?: string
}

export const ContactFieldsInfo: FC<ContactFieldsInfoProps> = ({
  loading,
  values,
  onEdit,
  onSwitch,
  onClose,
  type = 'contact-picker',
  role
}) => {
  return (
    <ContactFields
      initialValues={values}
      initialTouched={{
        firstName: true,
        lastName: true,
        email: true,
        phoneNumber: true,
        phoneNumberCountryCode: true,
        jobTitle: true,
        providedOrganizationName: true
      }}
      hiddenFields={{
        jobTitle: type === 'project-affiliations',
        providedOrganizationName: type === 'project-affiliations',
        changeReason: true
      }}
      requiredFields={{
        firstName: true,
        lastName: true,
        email: true,
        phoneNumber: true,
        phoneNumberCountryCode: true,
        jobTitle: true
      }}
      readonlyFields={{
        firstName: true,
        lastName: true,
        email: true,
        phoneNumber: true,
        phoneNumberCountryCode: true,
        jobTitle: true,
        providedOrganizationName: true
      }}
      title={
        <>
          <Box
            sx={{
              marginBottom: '25px',
              fontWeight: 'bold',
              fontSize: 20,
              lineHeight: '25px',
              color: 'primary.main',
              textAlign: 'center'
            }}
          >
            {type === 'project-affiliations' && !isNil(role)
              ? (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px', justifyContent: 'center' }}>
                  <Trans>PROJECT_AFFILIATIONS_EDIT_TITLE</Trans>
                  <Box>{role}</Box>
                </Box>)
              : <Trans>EDIT_LEGAL_CONTACT_TITLE</Trans>}
          </Box>
          <AlertBanner
            title={<Trans>EDIT_LEGAL_CONTACT_BANNER_TITLE</Trans>}
            description={<Trans>EDIT_LEGAL_CONTACT_BANNER_DESCRIPTION</Trans>}
            sx={{ marginBottom: '24px' }}
          />
        </>
      }
    >
      {({ values: { firstName, lastName, email }, isValid }) => {
        const handleEdit = (): void => {
          onEdit(!isValid)
        }
        return (
          <>
            <Button
              fullWidth
              color='primary'
              variant='contained'
              onClick={handleEdit}
            >
              <Trans>UPDATE_CONTACT_INFO_BTN</Trans>
            </Button>
            <Box sx={{ display: 'flex', gap: '16px', marginTop: '16px' }}>
              <Button
                fullWidth
                color='primary'
                variant='outlined'
                onClick={onSwitch}
              >
                <Trans>SWITCH_CONTACT_BTN</Trans>
              </Button>
              <CustomButton
                variant='outlined'
                sx={{ height: '35px' }}
                onClick={onClose}
              >
                <Trans>CLOSE_BTN</Trans>
              </CustomButton>
            </Box>
            {loading && (
              <div style={{ marginTop: 15, height: 100 }}>
                <Loading isNotFixed />
              </div>
            )}
          </>
        )
      }}
    </ContactFields>
  )
}
